import { basedir } from '../lib/helpers'

addEventListener('DOMContentLoaded', () => {

    const liElements = Array.from(document.querySelectorAll('ul.sortable > li')) as HTMLElement[]

    liElements.forEach(listItem => {
        const icon = document.createElement('i');
        icon.classList.add('icon-move');
        listItem.prepend(icon);

        listItem.setAttribute('draggable', 'true');

        listItem.addEventListener('dragstart', dragStart);
        listItem.addEventListener('dragover', dragOver);
        listItem.addEventListener('drop', dragDrop);
        listItem.addEventListener('dragend', dragEnd);
    });
})

let draggedItem = null;
let originalOrder = [];

function dragStart(e) {
    this.classList.add('dragging');
    draggedItem = this;
    setTimeout(() => {
        this.style.opacity = 0.3;
    }, 0);

    const list = this.parentNode;
    originalOrder = Array.from(list.children) as HTMLElement[];
}

function dragOver(e) {
    e.preventDefault();
    if (draggedItem != this) {
        const bounding = this.getBoundingClientRect();
        const offset = e.clientY - bounding.top;
        if (offset < bounding.height / 2) {
            this.parentNode.insertBefore(draggedItem, this);
        } else {
            this.parentNode.insertBefore(draggedItem, this.nextSibling);
        }
    }
}

function dragDrop(e) {
    e.preventDefault();
    if (draggedItem != this) {
        const bounding = this.getBoundingClientRect();
        const offset = e.clientY - bounding.top;

        if (offset < bounding.height / 2) {
            this.parentNode.insertBefore(draggedItem, this);
        } else {
            this.parentNode.insertBefore(draggedItem, this.nextSibling);
        }
    }
}

function dragEnd(e) {
    this.classList.remove('dragging');
    e.preventDefault();
    this.style.opacity = '';
    draggedItem = null;

    const idOrder = [];
    const liOrder = this.parentNode.querySelectorAll('li');
    liOrder.forEach(liItem => {
        idOrder.push(liItem.id);
    })
    const tableName = this.parentNode.getAttribute('name');
    const projectId = this.parentNode.getAttribute('project_id');

    var json = {
        table: tableName,
        project_id: projectId,
        item_order: idOrder
    };

    const url = basedir() + `/api/cms/table/sort`;

    const postData = async () => {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(json)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            if (!data.ok) {
                revertOrder(this.parentNode);
            }
        } catch (error) {
            revertOrder(this.parentNode);
        }
    };
    postData();
}

function revertOrder(list) {
    list.innerHTML = '';

    originalOrder.forEach((item) => {
        list.appendChild(item);
    });
}